import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useState } from 'react';
import type { TabelaPrecoProduto } from '@/features/tabela-preco/types/TabelaPrecoProduto';
import type { Dialog } from '@/std/dialog/types';
import { Container } from '@/components/Container';
import { ProdutoTabTabelaPrecoDrawerExcecaoForm } from './ProdutoTabTabelaPrecoDrawerExcecaoForm';

export function ProdutoTabTabelaPrecoDrawerExcecao({
    dialog,
    tabelaPreco,
    produtoIdpk,
}: {
    dialog: Dialog<TabelaPrecoProduto>;
    tabelaPreco: TabelaPrecoProduto;
    produtoIdpk: number;
}) {
    const [adicionandoExcecao, setAdicionandoExcecao] = useState(false);

    return (
        <Container className='mt-4' title='Exceção'>
            {tabelaPreco.tabela_preco_excecao || adicionandoExcecao ? (
                <ProdutoTabTabelaPrecoDrawerExcecaoForm
                    dialog={dialog}
                    produtoIdpk={produtoIdpk}
                    tabelaPreco={tabelaPreco}
                />
            ) : (
                <div className='flex flex-col items-center gap-4'>
                    <span>Não há exceção para esta tabela de preço.</span>

                    <Button
                        icon={<PlusOutlined />}
                        onClick={() => setAdicionandoExcecao(true)}
                        type='primary'
                    >
                        Adicionar exceção
                    </Button>
                </div>
            )}
        </Container>
    );
}
